import React from "react"
import { Typography, Grid } from "@mui/material"
import { Formik } from "formik"
import { useDispatch, useSelector } from "react-redux"
import AppTextField from "components/StyledComponents/AppTextField"
import AppSelect from "components/StyledComponents/AppSelect"
import AppButton from "components/StyledComponents/AppButton"
import CommonModal from "components/CommonModal"
import { validationSchemaVipGroupSection } from "helpers/validationSchema"
import { createVipGroupSectionAction, updateVipGroupSectionAction } from "redux/superAdmin/actions"

const SectionModal = ({ open, onClose, isEdit, sectionData }) => {
  const dispatch = useDispatch()
  const formikRef = React.useRef()
  const { notableGroupTypeId } = useSelector((store) => store?.superAdmin)

  React.useEffect(() => {
    if (open && formikRef.current) {
      formikRef.current.resetForm()
    }
  }, [open])

  const initialValues = {
    name: isEdit ? sectionData?.field_label : "",
    type: isEdit ? sectionData?.field_type : "",
    highlight_type: notableGroupTypeId
  }

  const sectionTypes = [
    { label: "Details", value: "Details" },
    { label: "Image Scroll", value: "Image_Scroll" },
    { label: "Array", value: "Array" }
  ]

  const handleSubmit = (values) => {
    const payload = {
      highlight_type: notableGroupTypeId,
      field_name: values.name,
      field_label: values.name,
      field_type: values.type
    }
    if (isEdit) {
      dispatch(updateVipGroupSectionAction({ id: sectionData.id, payload, onClose }))
    } else {
      dispatch(createVipGroupSectionAction({ payload, onClose }))
    }
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchemaVipGroupSection}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {(formik) => (
        <CommonModal
          open={open}
          onClose={onClose}
          maxWidth="sm"
          hideAction={true} // We use custom buttons for isEdit logic
        >
          <Typography variant="h2" className="mb-4 text-center">
            {isEdit ? "Edit Section" : "Add Section"}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <AppTextField
                name="name"
                label="Section Name"
                placeholder="Enter section name"
                value={formik.values.name}
                onChange={formik.handleChange}
                isUpperCase={true}
                isRequired={true}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <AppSelect
                name="type"
                label="Section Type"
                placeholder="Select section type"
                value={formik.values.type}
                isUpperCase={true}
                isRequired={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                menuItems={sectionTypes}
                error={formik.errors.type}
                touched={formik.touched.type}
              />
            </Grid>
            <Grid item xs={12} className="d-flex justify-content-center gap-3 mt-2">
              <AppButton onClick={onClose} variant="outlined" sx={{ height: 48, width: 150 }}>
                Cancel
              </AppButton>
              <AppButton onClick={formik.handleSubmit} sx={{ height: 48, width: 150 }}>
                {isEdit ? "Update" : "Save"}
              </AppButton>
            </Grid>
          </Grid>
        </CommonModal>
      )}
    </Formik>
  )
}

export default SectionModal
